import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import { forexApi, type OperatorOwner } from '@/lib/forex-api';

export default function MerchantDetailPage() {
  const [params] = useSearchParams();
  const ownerRef = params.get('id') || '';
  const [owner, setOwner] = useState<OperatorOwner | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let live = true;
    setLoading(true); setError(''); setOwner(null);
    forexApi.listOperatorOwners()
      .then(data => { if (live) setOwner(data.items.find(item => item.owner_ref === ownerRef) || null); })
      .catch(() => { if (live) setError('组织详情暂不可用，请稍后重试。'); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [ownerRef]);

  return <div className="space-y-5">
    <Breadcrumb items={[{ label: '外汇运营', href: '/forex/merchants' }, { label: '组织详情' }]} />
    {loading ? <p className="rounded-lg border bg-white p-6 text-sm">加载中...</p> : error ? <p role="alert" className="rounded-lg border bg-white p-6 text-sm text-red-600">{error}</p> : !owner ?
      <div className="rounded-lg border bg-white p-6 text-sm">组织不存在。<Link className="ml-2 text-brand" to="/forex/merchants">返回列表</Link></div> : <>
      <div className="rounded-lg border border-surface-border bg-white p-5">
        <h2 className="text-lg font-semibold text-text-primary">{owner.name}</h2>
        <p className="mt-1 text-xs text-text-muted">{owner.owner_ref} · {owner.node_type === 'company' ? '公司' : owner.node_type === 'team' ? '团队' : '未归类'} · {owner.status === 'active' ? '已启用' : '已暂停'}</p>
        <div className="mt-5 grid grid-cols-1 gap-3 text-xs md:grid-cols-2">
          <div>所属公司：{owner.company_ref || '未提供'}</div>
          <div>上级组织：{owner.parent_owner_ref || '无'}</div>
          <div>联系人：{owner.contact_person || '未提供'}</div>
          <div>当前智能体：{owner.master_account_count ?? '—'}</div>
        </div>
      </div>
      <div className="flex gap-4 text-sm text-brand">
        <Link to={`/forex/merchants?tab=members&owner_ref=${encodeURIComponent(owner.owner_ref)}`}>团队人员与邀请码</Link>
        <Link to={`/forex/merchants?tab=users&owner_ref=${encodeURIComponent(owner.owner_ref)}`}>邀请用户</Link>
        <Link to={`/forex/profit-dashboard?owner_ref=${encodeURIComponent(owner.owner_ref)}`}>查看盈利</Link>
      </div>
    </>}
  </div>;
}
